/**
 * features/company/hooks.ts
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CompanyInput } from '@ft/core';
import { api } from '~/lib/api';
import { queryKeys } from '~/lib/query-client';
import type { Company } from '~/lib/types';

export function useCompany() {
  return useQuery({
    queryKey: queryKeys.company,
    queryFn: () => api.get<Company>('/api/company'),
    // ข้อมูลบริษัทไม่ค่อยเปลี่ยน แคชได้นานกว่ารายการทั่วไป
    staleTime: 5 * 60_000,
  });
}

export function useUpdateCompany() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: CompanyInput) => api.put<Company>('/api/company', input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.company });
    },
  });
}

export function useUpdateCompanyLogo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (dataUri: string) => api.put<Company>('/api/company/logo', { dataUri }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.company });
    },
  });
}

export function useDeleteCompanyLogo() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api.delete<Company>('/api/company/logo'),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.company });
    },
  });
}
